import { render } from "./CardSocialTraffic.vue?vue&type=template&id=9e372d2c"
const script = {}

import exportComponent from "D:\\Desktop\\项目\\陈观梅\\vue-notus-main\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__